import { dataKit, documentKit, snowball } from 'app/fragments/compositions/mindmap'
import { EditorNextFile } from 'client/types/file'
import { openDocWithInject } from 'utils/import-file'

export const useMarkdownToMindmap = () => {
  const injectTheme = (content: documentKit.Document): documentKit.Document => {
    const colorTheme = dataKit.getColorThemeById(snowball.NEW_FILE_DEFAULT_COLOR_THEME_ID)
    const skeletonTheme = dataKit.getSkeletonThemeById(snowball.NEW_FILE_DEFAULT_SKELETON_THEME_ID)
    return dataKit.combineTheme(content.sheets[0], {
      colorTheme,
      skeletonTheme,
    }).ownerDocument
  }

  const normalMarkdown = (markdownText: string) => {
    return markdownText.split('\n').filter(Boolean).join('\n').trim()
  }

  const handleConvertMarkdownToXmind = async (markdownText: string) => {
    if (!markdownText) {
      logger.warn('No markdown text to convert')
      return
    }
    const { importMarkdownV3: importMarkdown } = await import('@xmindltd/snowdust/lib/esm/importer/markdown_v3')
    const encoder = new TextEncoder()
    const markdownBuffer = encoder.encode(normalMarkdown(markdownText))
    const xmindFile = await importMarkdown(markdownBuffer)

    const xmindDocument = injectTheme((await openDocWithInject(xmindFile, true)).doc)
    return xmindDocument
  }

  const injectContentToDocument = async (doc: documentKit.Document, sourceDoc: documentKit.Document) => {
    const sourceDocSerializer = (await dataKit.serializeDocument(sourceDoc)) as EditorNextFile
    const newDocSerializer = (await dataKit.serializeDocument(doc)) as EditorNextFile
    // @ts-ignore
    sourceDocSerializer.content[0].rootTopic = newDocSerializer.content[0].rootTopic
    return await dataKit.deserializeDocument(sourceDocSerializer)
  }

  return {
    handleConvertMarkdownToXmind,
    injectContentToDocument,
  }
}
